import { faCloudUpload } from "@fortawesome/pro-regular-svg-icons/faCloudUpload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { IconButtonCancel } from "components/iconButtons";
import { MprcPasteContainer } from "components/MprcPasteContainer";
import { useMprcTheme } from "components/MprcThemeProvider";
import { useSnackbar } from "notistack";
import * as React from 'react';
import Dropzone, { Accept } from 'react-dropzone';
import "react-image-crop/dist/ReactCrop.css";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface FileUploadProps {
    acceptedFiles?: Accept;
    selectedFile: File | null;
    onError: (message: string) => void;
    onSelectFile: (file: File | null) => void;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const MprcFileUpload: React.FC<FileUploadProps> = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const { theme: mprcTheme } = useMprcTheme();
    const theme = useTheme();

    const { acceptedFiles, selectedFile, onSelectFile } = props;

    const allowImages = acceptedFiles != null && Object.keys(acceptedFiles).find(p => p.startsWith("image")) != null;

    ///
    const onLocalFileSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            onSelectFile(e.target.files[0]);
        }
    };

    ///
    const handlePaste = (files: File[]) => {
        if (files && files.length > 0) {
            onSelectFile(files[0]);
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <input
                id="FileSelection"
                type="file"
                accept={acceptedFiles && Object.values(acceptedFiles)[0].join(",")}
                style={{ display: "none" }}
                onChange={onLocalFileSelected}
            />

            <Grid container wrap="nowrap" width="unset" >
                <Grid>
                    {
                        selectedFile == null
                            ? (
                                <>
                                    {allowImages &&
                                        <MprcPasteContainer
                                            onPaste={files => handlePaste(files)}
                                            onError={err => console.error(err)}
                                        />
                                    }
                                    <Dropzone
                                        multiple={false}
                                        accept={props.acceptedFiles}
                                        onDropRejected={
                                            () => enqueueSnackbar(mprcTheme.MprcImageSelection.fileNotAccept, { variant: "error" })
                                        }
                                        onDropAccepted={
                                            (e) => {
                                                onSelectFile(e[0]);
                                            }
                                        }
                                    >
                                        {
                                            ({ getRootProps, getInputProps, isDragActive }) => {
                                                return (
                                                    <Box
                                                        {...getRootProps({
                                                            style:
                                                            {
                                                                borderWidth: 1,
                                                                padding: theme.spacing(1),
                                                                borderStyle: "solid",
                                                                borderColor: isDragActive ? theme.palette.success.main : theme.palette.muted.dark
                                                            }
                                                        })}
                                                    >
                                                        <input {...getInputProps()} />

                                                        <Grid container justifyContent="center" spacing={1}>
                                                            <Grid>
                                                                <FontAwesomeIcon icon={faCloudUpload} fixedWidth size="4x" />
                                                            </Grid>
                                                            <Grid style={{ alignSelf: "center", textAlign: "center" }}>
                                                                <Typography variant="h6">
                                                                    <span>{mprcTheme.MprcImageSelection.dropHereText1}</span>
                                                                    {
                                                                        allowImages &&
                                                                        <>
                                                                            <br />
                                                                            <span>{mprcTheme.MprcImageSelection.dropHereText2}</span>
                                                                            <br />
                                                                            <span>{mprcTheme.MprcImageSelection.dropHereText3}</span>
                                                                        </>
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                );
                                            }
                                        }
                                    </Dropzone>
                                </>
                            )
                            : (
                                <Grid container justifyContent="center" alignItems="center" spacing={1}>
                                    <Grid>
                                        <FontAwesomeIcon icon={faCloudUpload} fixedWidth size="4x" />
                                    </Grid>
                                    <Grid>
                                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                                            <Grid>
                                                <span>{selectedFile.name}</span>
                                                <br />
                                                <small><span>{selectedFile.type}</span></small>
                                            </Grid>
                                            <Grid>
                                                <IconButtonCancel size="small" onClick={() => onSelectFile(null)} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                    }
                </Grid>
            </Grid>
        </>
    );
};
